import axios from 'axios'
import Qs from 'qs'

export const isRetakeOptions = [{ name: '新作', value: false }, { name: '改訂 / 修正', value: true }]

const kindOptions = async () => {
  const kindsResponse = await axios.get('/kinds.json')
  return { kindOptions: kindsResponse.data.map(x => ({ kindId: x.id, name: x.name })) }
}

const durationOptions = async () => {
  const durationsResponse = await axios.get('/durations.json')
  return { durationOptions: durationsResponse.data.map(x => ({ id: x.id, name: x.second })) }
}

const salesOptions = async () => {
  const salesResponse = await axios.get('/users/sales.json', { params: { items_count: 2000 } })
  return { salesOptions: salesResponse.data.map(x => ({ id: x.id, name: x.name })) }
}

const productionUserOptions = async (currentUserId) => {
  const usersResponse = await axios.get(`/users/${currentUserId}/shareable_users.json`, { params: { items_count: 2000 } })
  return { productionUserOptions: usersResponse.data.map(x => ({ id: x.id, name: x.name })) }
}

const cameramanOptions = async () => {
  const cameramenResponse = await axios.get('/cameramen.json', { params: { items_count: 2000, is_selectable: true } })
  const options = cameramenResponse.data.map(x => {
    let name = x.full_name
    if (x.note) name = `${x.full_name}(${x.note})`
    return { id: x.id, name: name }
  })
  return { cameramanOptions: options }
}

const categoryOptions = async () => {
  const categoriesResponse = await axios.get('/categories.json')
  const options = categoriesResponse.data.map(x => ({
    id: x.id,
    name: x.name,
    workerGroupIds: x.worker_group_ids,
    outsideResourceGroupId: x.outside_resource_group_id,
    displayOrder: x.display_order,
    color: x.color
  }))
  return { categoryOptions: options }
}

const designationTypeOptions = async () => {
  const designationTypesResponse = await axios.get('/designation_types.json', {
    params: {
      items_count: 2000,
      q: { is_visible_eq: true }
    },
    paramsSerializer: function (params) {
      // ransack で処理できるよう q[is_visible_eq]=true へのフォーマット変換します
      return Qs.stringify(params, { arrayFormat: 'brackets' })
    }
  })
  const options = [{ id: null, name: '指定なし' }, ...designationTypesResponse.data.map(x => ({ id: x.id, name: x.name }))]
  return { designationTypeOptions: options }
}

export const workerGroupOptions = async () => {
  const workerGroupsResponse = await axios.get('/worker_groups/form_options.json')
  return { workerGroupOptions: workerGroupsResponse.data }
}

export const filteredWorkerOptions = (workerGroupOptions, designation) => {
  const workerOptions = []
  workerGroupOptions.filter((workerGroup) => (designation.workerGroupIds.includes(workerGroup.id))).forEach((workerGroup) => {
    workerOptions.push(...workerGroup.workers)
  })
  // 作業者の重複排除と整形
  const resultOptions = Object.values(workerOptions).map(x => ({ id: x.id, name: x.full_name }))
  return [{ id: null, name: '指定なし' }, ...resultOptions]
}

export const recipientCandidates = async (currentUserId) => {
  const usersResponse = await axios.get(`/users/${currentUserId}/recipient_candidates.json`)
  return usersResponse.data.map(x => ({ id: x.id, name: x.name }))
}

export const options = async (currentUserId) => {
  const results = await Promise.all([
    kindOptions(), durationOptions(), salesOptions(), productionUserOptions(currentUserId), cameramanOptions(),
    categoryOptions(), designationTypeOptions(), workerGroupOptions()
  ])

  return Object.assign(...results)
}
